import template from './rooms-for-count.jade';
import validation from '../../../../services/validation';
import plainRoomsCount from '../../../../enums/plain-rooms-count';

export default angular
    .module('cian.addForm.roomsForCount', [])
    .directive('cianAfRoomsForCount', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
            fieldTitle: '@',
            viewTypes: '=',
            strategy: '@',
        },
        controller: ['$timeout', 'deviceService', function($timeout, deviceService) {
            this.isMobile = deviceService.isMobile;
            this.isSeveral = false;
            this.items = plainRoomsCount;
            this.ad.flatType = 'rooms';

            this.getRoomsMax = () => {
                let limit = this.ad.roomsCount;
                if ((this.strategy === 'roomsForSaleCount' || this.strategy === 'roomsForRentCount' || this.strategy === 'roomsForRentCountDaily') && plainRoomsCount[plainRoomsCount.length - 1].value !== limit && limit) {
                    limit -= 1;
                }
                return limit;
            };

            this.validation = validation(this.form, 'roomsForCount', {
                required: 'Выберите значение',
                max: 'Количество комнат должно быть меньше общего числа комнат в квартире',
            });
            this.validationRoomType = validation(this.form, 'roomType', {
            });

            this.checkboxTypeChange = () => {
                if (this.checkboxType.separate && this.checkboxType.combined) {
                    this.ad.roomType = 'both';
                }
                else if (this.checkboxType.separate) {
                    this.ad.roomType = 'separate';
                }
                else if (this.checkboxType.combined) {
                    this.ad.roomType = 'combined';
                }
                else {
                    this.ad.roomType = undefined;
                }
            };

            this.radioTypeChange = () => {
                if (!this.radioType) {
                    this.ad.roomType = undefined;
                    return;
                }

                this.ad.roomType = this.radioType;
            };

            const setValueFromModel = () => {
                this.checkboxType = {};

                if (this.ad.roomType === 'both') {
                    this.checkboxType.separate = true;
                    this.checkboxType.combined = true;
                    this.radioType = 'combined'; // set first
                }
                else if (this.ad.roomType === 'separate') {
                    this.checkboxType.separate = true;
                    this.checkboxType.combined = false;
                    this.radioType = 'separate';
                }
                else if (this.ad.roomType === 'combined') {
                    this.checkboxType.separate = false;
                    this.checkboxType.combined = true;
                    this.radioType = 'combined';
                }
                else {
                    this.checkboxType.separate = false;
                    this.checkboxType.combined = false;
                    this.radioType = '';
                }

                /*
                Если вид контролов радио и перед сменой вида radio/checkbox было выбрано два значения(ad.roomType === 'both')
                Вызываем событие которое установит значение в глобальную модель(ad.roomType) из локальной модели радио(radioType)
                В данном случае будет ad.roomType = 'combined';
                */
                if (!this.isSeveral && this.ad.roomType === 'both') {
                    this.radioTypeChange();
                }
            };

            this.onChangeCount = () => {
                this.isSeveral = this.ad.roomsForSaleCount > 1;
                setValueFromModel();
                repositionTooltip();
            };

            // переоткрываем тултип из-за динамической ширины дропдауна
            // todo: надо придумать что-то получше, тултип моргает - не красиво
            const repositionTooltip = () => {
                this.hideTooltip = true;
                $timeout(() => this.hideTooltip = undefined);
            };

      this.onChangeCount();
        }],
        controllerAs: 'roomsForCount',
        template,
    }))
    .name;
